import React from 'react';

/**
 * Tab button for navigating between questions
 * Props:
 *   - questionNum: number
 *   - difficulty: string
 *   - active: boolean
 *   - onClick: () => void
 */
const QuestionTab = ({ questionNum, difficulty, active, onClick }) => {
  const className = `question-tab${active ? ' active' : ''}`;

  return (
    <button className={className} onClick={onClick}>
      <span className="question-tab-num">{String(questionNum).padStart(2, '0')}</span>
      <span className="question-tab-difficulty">{difficulty}</span>
    </button>
  );
};

export default QuestionTab;
